import { Trans, useTranslation } from 'react-i18next';
import { ErrorWarningtraiangle } from '../../../assets/icons';
import { SUPPORT_EMAIL } from '../../../constant/Text.constant';
import { Card, ColorType, getHexColorByType, Icon, Label, LabelType } from '../../_ui';

export const ChargerLicenseExpired = () => {
  const { t } = useTranslation();

  const warningMsg2 = (
    <Trans i18nKey='charger_license_expired_warning_msg_2'>
      <a
        target='_blank'
        href={`mailto:${SUPPORT_EMAIL}`}
        rel='noreferrer'
        className={LabelType.LABEL_S_MEDIUM}
        style={{ color: getHexColorByType(ColorType.DENIM) }}
      >
        This text will be replaced by actual link text during translation
      </a>
    </Trans>
  );

  return (
    <div className='w-full mt-2 mb-4'>
      <Card className='border-2 border-warning' bg='bg-warning0'>
        <div className='flex flex-row gap-3'>
          <div className='flex flex-row'>
            <Icon color={ColorType.WARNING} src={ErrorWarningtraiangle} />
          </div>
          <div className='flex flex-col'>
            <Label
              text={t('charger_license_expired_warning')}
              type={LabelType.LABEL_M}
              color={ColorType.BLACK}
              className='mb-2'
            />
            <Label
              text={t('charger_license_expired_warning_msg_1')}
              type={LabelType.BODY3}
              color={ColorType.GREY6}
              className='mb-2'
            />
            <Label text={warningMsg2} type={LabelType.BODY3} color={ColorType.GREY6} />
          </div>
        </div>
      </Card>
    </div>
  );
};

ChargerLicenseExpired.displayName = 'ChargerLicenseExpiredComponent';
